
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const VideoSection = () => {



  const [videoData, setService] = useState([]);


  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL


  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);





  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/videos`)
      .then((res) => res.json())
      .then((info) => setService(info));
  }, []);


  return (


    <>
      {
        videoData.map(v => v.pageSlug === page.pageSlug && <div>
          <div className="offer-videosection mt-5">
            <div className="container mt-5">
              <div className="row position-relative">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                  <div className="position-relative">
                    <a
                      className="popup-vimeo"
                      href={v.videoLink}
                    >
                      <figure className="mb-0 vediosession">
                        <img
                          className="thumb img-fluid"
                          style={{ cursor: "pointer" }}
                          src={v.videoImage}
                          alt="Video thumbnail"
                        />
                      </figure>
                    </a>
                  </div>
                </div>
                <figure className="mb-0 image-sidecircle">
                  <img
                    className="img-fluid"
                    src="./assets/images/image-sidecircle.png"
                    alt="Decorative circle"
                  />
                </figure>
              </div>
            </div>
          </div>
          <section className="offer-section">
            <div className="container">
              <figure className="mb-0 offer-sidelayer">
                <img src="./assets/images/offer-sidelayer.png" alt />
              </figure>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="offer_content" data-aos="fade-down">
                    <h4 className="text-white">{v.headingVideo}</h4>
                    <h2 className="text-white">{v.subheadingVideo}</h2>
                    <p className="text-white">{v.TextVideo}</p>
                    <div className="offer-imagewrapper">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>)
      }

    </>

  );
};

export default VideoSection;

